// Menu Items
export const menuAbout = 'ABOUT';
export const menuSolutions = 'SOLUTIONS';
export const menuArticles = 'RESEARCH';
export const menuNews = 'NEWS';
export const menuContacts = 'CONTACTS';
export const menuRecruit = 'RECRUIT';

// About Submenu
export const aboutStory = 'Our Story';
export const aboutCompetency = 'Core Competency';
export const aboutHistory = 'History';
export const aboutPeople = 'People';
export const aboutPartner = 'Partner';
export const aboutCI = 'CI';

// Solutions Submenu
export const solutionsHealthcare = 'Digital Healthcare';
export const solutionsSports = 'Digital Sports';

// Articles Submenu
export const articlesMenu = 'Publications & Research';

// News Submenu
export const newsArticles = 'Articles';
export const newsNotice = 'Notice';
export const newsEvents = 'Events';

// Contacts Submenu
export const contactsMenu = 'Contacts';

// Recruit Submenu
export const recruitSystem = 'HR System';
export const recruitJobs = 'Job Openings';

export default {
  menuAbout,
  menuSolutions,
  menuArticles,
  menuNews,
  menuContacts,
  menuRecruit,
  aboutStory,
  aboutCompetency,
  aboutHistory,
  aboutPeople,
  aboutPartner,
  aboutCI,
  solutionsHealthcare,
  solutionsSports,
  articlesMenu,
  newsArticles,
  newsNotice,
  newsEvents,
  contactsMenu,
  recruitSystem,
  recruitJobs
};
